import React from 'react';
import { Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  removeSelectedPlantId,
  selectPresentAccordingToUserPlants,
  setSelectedPlantIds,
} from '../../../../ducks/plants';
import { plantFilters } from '../../../../utils/filters';
import FilterableList from '../../../../components/FilterableList';
import { plantSelectionTypesEnum } from '../../../../ducks/plants/types';
import SubjectCard from '../../../../components/SubjectCard';
import {
  booleanText,
  parseCopyRightText,
} from '../../../../utils/valuesToHumanReadable';
import { helpTextPlantPresentAccordingToModel } from '../../../../utils/text';

const SelectedPlants = () => {
  const dispatch = useDispatch();
  const selectedPlants = useSelector(selectPresentAccordingToUserPlants);

  if (selectedPlants.length === 0) {
    return (
      <Row className="mt-4 justify-content-center d-flex">
        <span>Nog geen planten geselecteerd</span>
      </Row>
    );
  }

  return (
    <FilterableList
      filterConfig={plantFilters}
      data={selectedPlants}
      searchableByProperties={['dutchName', 'scientificName']}
      quickSelect={{
        handleDeselectAll: () => {
          dispatch(setSelectedPlantIds({
            selectionType: plantSelectionTypesEnum.presentAccordingToUserIds,
            plantIds: [],
          }));
        },
        selectedCount: selectedPlants.length,
      }}
      render={(filteredData) => filteredData.map((plant) => (
        <SubjectCard
          key={plant.id}
          md={6}
          lg={4}
          title={plant.dutchName}
          subtitle={plant.scientificName}
          imagePath={plant.imagePath}
          copyrightText={parseCopyRightText(plant)}
          propertiesToList={[
            {
              key: 'Gemodelleerd in jouw gebied',
              help: helpTextPlantPresentAccordingToModel,
              value: booleanText(plant.isPresentAccordingToModel),
            },
          ]}
          ranges={plant.floweringMonths}
          rangesHeading="Bloeitijd"
          handleClick={() => dispatch(removeSelectedPlantId({
            selectionType: plantSelectionTypesEnum.presentAccordingToUserIds,
            plantId: plant.id,
          }))}
          isSelected
        />
      ))}
    />
  );
};

export default SelectedPlants;
